module.exports = __webpack_public_path__ + "static/media/paulface.66bb735f.png";